module.exports = __webpack_public_path__ + "img/magik.09dea3a9.png";